import { Display } from '../../constants/apis';
import type { DisplayClickPayload, DisplayImpressionPayload } from '../../types/modules';
import { ApiManager, SHOW_TOAST_HEADER } from '../axios-config';

export const displayClickApi = async (payload: DisplayClickPayload) => {
  return await ApiManager.put(`${Display}/click`, payload, { headers: { [SHOW_TOAST_HEADER]: false } });
};

export const displayImpressionApi = async (payload: DisplayImpressionPayload) => {
  return await ApiManager.put(`${Display}/impression`, payload, { headers: { [SHOW_TOAST_HEADER]: false } });
};
